// Display metadata for the Odoo Sync Logs module.

export const JOB_TYPE_LABELS = {
  RM_ODOO_SYNC_ADD: { label: "Raw Material", action: "Add", group: "Master" },
  RM_ODOO_SYNC_UPDATE: { label: "Raw Material", action: "Update", group: "Master" },
  FG_ODOO_SYNC_ADD: { label: "F&B Item", action: "Add", group: "Master" },
  FG_ODOO_SYNC_UPDATE: { label: "F&B Item", action: "Update", group: "Master" },
  RC_ODOO_SYNC_ADD: { label: "Rate Card", action: "Add", group: "Master" },
  RC_ODOO_SYNC_UPDATE: { label: "Rate Card", action: "Update", group: "Master" },
  MBI_ODOO_SYNC_ADD: { label: "Manual Bill Item", action: "Add", group: "Master" },
  MBI_ODOO_SYNC_UPDATE: { label: "Manual Bill Item", action: "Update", group: "Master" },
  ADDONS_ODOO_SYNC_ADD: { label: "Add-on Charges", action: "Add", group: "Master" },
  PARTNER_ODOO_SYNC_ADD: { label: "Partner", action: "Add", group: "Master" },
  PARTNER_ODOO_SYNC_UPDATE: { label: "Partner", action: "Update", group: "Master" },
  MOVIE_ODOO_SYNC_ADD: { label: "Movie", action: "Add", group: "Master" },
  PAYMENT_METHOD_ODOO_SYNC_ADD: { label: "Payment Methods", action: "Add", group: "Master" },
  BILL_ODOO_SYNC: { label: "Vendor Bill (GRN)", action: "Create", group: "Purchase" },
  RETURN_VENDORBILL_ODOO_SYNC: { label: "Goods Return", action: "Create", group: "Purchase" },
  INVOICE_ODOO_SYNC: { label: "Manual Invoice", action: "Create", group: "Sales" },
  RECEIPT_ODOO_SYNC: { label: "Sales Receipt", action: "Create", group: "Sales" },
  RECEIPT_REFUND_ODOO_SYNC: { label: "Refund", action: "Create", group: "Sales" },
  RECEIPT_ODOO_RE_SYNC_SCRIPT: { label: "Sales Receipt", action: "Re-sync", group: "Sales" },
};

export const jobTypeMeta = (jobType) =>
  JOB_TYPE_LABELS[jobType] || {
    label: jobType || "Unknown",
    action: "",
    group: "Other",
  };

export const STATUS_META = {
  Completed: { label: "Synced", cls: "osl-badge--success" },
  Failed: { label: "Failed", cls: "osl-badge--danger" },
  Pending: { label: "Pending", cls: "osl-badge--warning" },
};

export const RESEND_STATUS_META = {
  None: { label: "—", cls: "" },
  Queued: { label: "Queued", cls: "osl-badge--info" },
  Processing: { label: "Processing", cls: "osl-badge--info osl-badge--pulse" },
  Done: { label: "Resent OK", cls: "osl-badge--success-soft" },
  Failed: { label: "Resend failed", cls: "osl-badge--danger-soft" },
};

export const TRIGGER_META = {
  AUTO: { label: "Auto", cls: "osl-tag" },
  RESEND: { label: "Re-run", cls: "osl-tag osl-tag--violet" },
  REPLAY: { label: "Replay", cls: "osl-tag osl-tag--blue" },
};

export const RESEND_MODE_HELP = {
  RERUN:
    "Runs the original job again. The payload is rebuilt from current data, and sync flags (is_erp_sync, odoo_sync_jobs) are updated as usual. Recommended.",
  REPLAY:
    "Sends the exact stored request body to the same Odoo endpoint with a fresh token. Only odoo_sync_jobs is marked complete. Entity sync flags are NOT updated.",
};

export const prettyJSON = (value) => {
  if (value === null || value === undefined || value === "") return "";
  if (typeof value === "string") {
    try {
      return JSON.stringify(JSON.parse(value), null, 2);
    } catch (e) {
      return value;
    }
  }
  try {
    return JSON.stringify(value, null, 2);
  } catch (e) {
    return String(value);
  }
};

export const formatDuration = (ms) => {
  if (ms === null || ms === undefined || ms === "") return "—";
  const n = Number(ms);
  if (isNaN(n)) return "—";
  if (n < 1000) return `${n} ms`;
  return `${(n / 1000).toFixed(n < 10000 ? 2 : 1)} s`;
};



// WEBPACK FOOTER //
// ./src/components/Pages/MasterContainer/OdooSyncLogs/odooLogsMeta.js